import { AttendingEventType } from "store/attendingEvents/attendingEvents.types";
import { RootState } from "store/types";
import { selectUserId } from "store/user/user.selectors";
import { User } from "types";

export const selectEventDetail = (state: RootState) => state.eventDetails;

export const selectEventStatus = (state: RootState) => {
    const selectedEventDetails = selectEventDetail(state);
    const user_id = selectUserId(state);
    const user = selectedEventDetails.data?.users?.find((user: { user_id: User["id"] }) => user.user_id === user_id);
    
    if (!user) return undefined;
    
    if (user.part_type === AttendingEventType.HOST) {
        return user.part_type;
    }
    return user.status_type;
};